<template>
  <div class="bestaetigung">
    <Header />
    <Hero step="error" />
    <Status_Fail />
    <Restart />
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Hero from '@/components/Hero.vue'
import Status_Fail from '@/components/Status_Fail.vue'
import Footer from '@/components/Footer.vue'
import Restart from '@/components/Restart.vue'

export default {
  name: 'FehlerView',
  components: {
    Header,
    Hero,
    Status_Fail,
    Restart,
    Footer
  },
  data () {
    return {
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>
